import { cloneDeep } from 'lodash';
import { put, takeLatest } from 'redux-saga/effects';
import helpers from 'utils/helpers';

const { rp } = helpers;

const GET_SERIVCE_BOXES_REQUEST = 'GET_SERIVCE_BOXES_REQUEST';
const GET_SERIVCE_BOXES_SUCCESS = 'GET_SERIVCE_BOXES_SUCCESS';
const GET_SERIVCE_BOXES_FAILURE = 'GET_SERIVCE_BOXES_FAILURE';

const BUY_SERIVCE_BOXES_REQUEST = 'BUY_SERIVCE_BOXES_REQUEST';
const BUY_SERIVCE_BOXES_SUCCESS = 'BUY_SERIVCE_BOXES_SUCCESS';
const BUY_SERIVCE_BOXES_FAILURE = 'BUY_SERIVCE_BOXES_FAILURE';

export const getServiceBoxesRequest = params => ({
  type: GET_SERIVCE_BOXES_REQUEST,
  ...params
});

export const buyServiceBoxesRequest = params => ({
  type: BUY_SERIVCE_BOXES_REQUEST,
  ...params
});

function* getServiceBoxesMethod() {
  const options = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/services/buy-boxes`,
    json: true
  };

  try {
    const data = yield rp(options);
    const boxes = cloneDeep(data.data.serviceItems).map(box => {
      let attr = { name: {}, quantity: 0 };
      attr.name = box.name;
      box.serviceItemFields.forEach(
        field => (attr[field.name] = Number(field.value))
      );
      return attr;
    });
    if (data.success) {
      yield put({
        type: GET_SERIVCE_BOXES_SUCCESS,
        boxes
      });
    } else {
      yield put({ type: GET_SERIVCE_BOXES_FAILURE });
      helpers.message.error(window.t('common.err_msg.error'), 'boxes');
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_SERIVCE_BOXES_FAILURE });
    helpers.message.error(window.t('common.err_msg.error'), 'boxes');
  }
}

function* buyServiceBoxesMethod(action) {
  const { boxes, address } = action;
  const temp = { ...address };
  const date = temp.date;

  if (temp.ref === null || temp.ref === '') delete temp.ref;
  delete temp.date;

  const options = {
    method: 'POST',
    uri: `${process.env.REACT_APP_BASE_URL}/services/buy-boxes/stripe`,
    body: {
      details: {
        items: boxes.filter(box => box.quantity > 0),
        date: date
      },
      address: temp
    },
    json: true
  };

  try {
    const data = yield rp(options);
    if (data.success) {
      yield put({
        type: BUY_SERIVCE_BOXES_SUCCESS,
        data: data.data
      });
    } else {
      yield put({ type: BUY_SERIVCE_BOXES_FAILURE });
      let errorMessage;
      switch (data.code) {
        case '4031':
        case '1005':
        case '3002':
        case '3005':
        case '3006':
        case '1113':
          errorMessage = window.t(`error_code.payment-${data.code}`);
          break;
        case '3000':
          errorMessage = window.t('error_code.payment-fail');
          break;
        default:
          errorMessage = window.t('error_code.payment-error');
      }
      helpers.message.error(errorMessage, 'boxes');
    }
  } catch (e) {
    console.error(e);
    yield put({ type: BUY_SERIVCE_BOXES_FAILURE });
    helpers.message.error(window.t('error_code.payment-error'), 'boxes');
  }
}

function* saga() {
  yield takeLatest(GET_SERIVCE_BOXES_REQUEST, getServiceBoxesMethod);
  yield takeLatest(BUY_SERIVCE_BOXES_REQUEST, buyServiceBoxesMethod);
}

const reducer = (state = {}, action) => {
  switch (action.type) {
    case GET_SERIVCE_BOXES_REQUEST:
      return {
        ...state,
        loading: true,
        boxes: [],
        buyingStatus: false
      };
    case GET_SERIVCE_BOXES_SUCCESS:
      return {
        ...state,
        loading: false,
        boxes: action.boxes
      };
    case GET_SERIVCE_BOXES_FAILURE:
      return {
        ...state,
        loading: false,
        boxes: []
      };
    case BUY_SERIVCE_BOXES_REQUEST:
      return {
        ...state,
        buyingStatus: false,
        buyingLoading: true
      };
    case BUY_SERIVCE_BOXES_SUCCESS:
      return {
        ...state,
        buyingStatus: action.data,
        buyingLoading: false
      };
    case BUY_SERIVCE_BOXES_FAILURE:
      return {
        ...state,
        buyingStatus: {},
        buyingLoading: false
      };
    default:
      return state;
  }
};

export default {
  saga,
  reducer
};
